import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { environment } from '@teem/environments/environment';

declare var $;

@Component({
  selector: 'payments-tab-header',
  templateUrl: './payments-tab-header.component.html'
})
export class PaymentsTabHeaderComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Input() activeTab;
  @Input() invoicesCount;
  @Input() draftsCount;
  @Input() receivedPaymentsCount;
  @Input() failedPaymentsCount;
  @Input() userInfo: any;
  @Output() changeTab: EventEmitter<string> = new EventEmitter();
  @Output() onSearch: EventEmitter<string> = new EventEmitter();
  @Output() recordPayment: EventEmitter<any> = new EventEmitter();
  @Output() quickPayment: EventEmitter<any> = new EventEmitter();
  @Output() toggleTableMenu: EventEmitter<any> = new EventEmitter();
  @Output('filterByDate') _filterByDate: EventEmitter<any> = new EventEmitter();
  @Output('filterByAmount') _filterByAmount: EventEmitter<any> = new EventEmitter();
  @Output('filterByStatus') _filterByStatus: EventEmitter<any> = new EventEmitter();
  isSearch: boolean = false;
  isFilter: boolean = false;
  fromDate: any = '';
  toDate: any = '';
  minAmount: any = '';
  maxAmount: any = '';
  invoice_status: any = '';
  params: any = {};

  constructor() { }

  ngOnInit(): void {
  }

  toggleSearch() {
    this.isSearch = !this.isSearch;

    if(this.isSearch) {
      this.searchInput.nativeElement.focus();
    } else {
      this.searchInput.nativeElement.value = "";
      this.onSearch.emit("");
    }
  }

  toggleFilter() {
    this.isFilter = !this.isFilter;
    this.params = {};
    this.resetDateFilters();
    this.resetAmountFilters();
    this.resetStatusFilters();
    this.invoice_status = '';
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    },100);
  }

  clearAllFilter(){
    this.isFilter = !this.isFilter;
    this.params = {};
    this.resetDateFilters();
    this.resetAmountFilters();
    this.resetStatusFilters();
    this.invoice_status = '';
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    },100);
  }

  resetDateFilters() {
    if(this.fromDate || this.toDate) {
      this.fromDate = "";
      this.toDate = "";
      this.filterByDate();
    }
  }

  resetAmountFilters() {
    if(this.minAmount || this.maxAmount) {
      this.minAmount = "";
      this.maxAmount = "";
      this.filterByAmount();
    }
  }

  resetStatusFilters() {
    if(this.invoice_status) {
      this.invoice_status = "";
      this.filterByStatus();
    }
  }

  exportXls() {
    if (this.activeTab == 'all-invoices') {
      (window as any).open(`${environment.baseUrl}/invoices/download?from=${this.fromDate}&to=${this.toDate}&status=${this.invoice_status}`, '_self', 'location=yes');
    } else if (this.activeTab == 'received-payments') {
      (window as any).open(`${environment.baseUrl}/invoice-payment/download?from=${this.fromDate}&to=${this.toDate}&status=${this.invoice_status}`, '_self', 'location=yes');
    }
  }

  filterByDate() {
    if(this.fromDate) {
      this.params.from_date = this.fromDate;
    }
    if(this.toDate) {
      this.params.to_date = this.toDate; 
    }

    this._filterByDate.emit(this.params);
  }

  filterByAmount() {
    // if(this.minAmount) {
      this.params.min_amount = this.minAmount;
    // }
    // if(this.maxAmount) {
      this.params.max_amount = this.maxAmount; 
    // }

    this._filterByAmount.emit(this.params);
  }

  filterByStatus() {
    this.params.invoice_status = "";
    if(this.invoice_status) {
      this.params.invoice_status = this.invoice_status;
    }

    this._filterByStatus.emit(this.params);
  }
}
